// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetTransactionByIdRequestModel from '../../model/get-transaction-by-id-request-model';
import GetTransactionByIdRequestDTO from '../dto/get-transaction-by-id-request-dto';
import dtoSchema from '../schemas/get-transaction-by-id-request-schema';

export default abstract class GetTransactionByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetTransactionByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  */
  id?: string;

  static toModel(dto: DeepPartial<GetTransactionByIdRequestDTO>): GetTransactionByIdRequestModel;
  static toModel(dto: DeepPartial<GetTransactionByIdRequestDTO> | undefined | null): GetTransactionByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetTransactionByIdRequestDTO> | undefined | null): GetTransactionByIdRequestModel | undefined {
    return dto ? new GetTransactionByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetTransactionByIdRequestModel> | GetTransactionByIdRequestModel): GetTransactionByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetTransactionByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetTransactionByIdRequestModel, can not map to GetTransactionByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
